import { render, staticRenderFns } from "./coffee-quiz-question-nested.vue?vue&type=template&id=f684d542&scoped=true&"
import script from "./coffee-quiz-question-nested.vue?vue&type=script&lang=js&"
export * from "./coffee-quiz-question-nested.vue?vue&type=script&lang=js&"
import style0 from "./coffee-quiz-question-nested.vue?vue&type=style&index=0&id=f684d542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f684d542",
  null
  
)

export default component.exports